import { cumulativeSignupToPaid, normalizeFunnel } from '../model/funnel';

export default function FunnelPanel({ funnel, onChange }) {
  const normalized = normalizeFunnel(funnel);
  const update = (patch) => onChange(normalizeFunnel({ ...normalized, ...patch }));
  const cumulative = cumulativeSignupToPaid(normalized);

  return (
    <section className="chart-card economics-panel">
      <h2>Signup funnel</h2>
      <p className="chart-hint">
        FFC order: <strong>signups → activate → paid</strong> (creates logos). Bank-link is{' '}
        <strong>Basic+ only</strong> — after paid, not a gate to paid. Cumulative signup→paid:{' '}
        <strong>{(cumulative * 100).toFixed(1)}%</strong>. The paid→bank-link rate is reported
        separately as expected linked paying logos.
      </p>

      <div className="economics-form-grid economics-form-grid-3">
        <label className="economics-field">
          <span>Signup → activate %</span>
          <input
            type="number"
            min="0"
            max="100"
            step="1"
            value={normalized.signupToActivatePct}
            onChange={(e) =>
              update({
                signupToActivatePct: Math.min(100, Math.max(0, parseFloat(e.target.value) || 0)),
              })
            }
          />
        </label>
        <label className="economics-field">
          <span>Activate → paid %</span>
          <input
            type="number"
            min="0"
            max="100"
            step="0.1"
            value={normalized.activateToPaidPct}
            onChange={(e) =>
              update({
                activateToPaidPct: Math.min(100, Math.max(0, parseFloat(e.target.value) || 0)),
              })
            }
          />
        </label>
        <label className="economics-field">
          <span>Paid → bank-link %</span>
          <input
            type="number"
            min="0"
            max="100"
            step="1"
            value={normalized.paidToBankLinkPct}
            onChange={(e) =>
              update({
                paidToBankLinkPct: Math.min(100, Math.max(0, parseFloat(e.target.value) || 0)),
              })
            }
          />
          <span className="economics-muted">
            Post-paid engagement / linked-logo volume — not in signup→paid
          </span>
        </label>
        <label className="economics-field">
          <span>Conversion lag (months)</span>
          <input
            type="number"
            min="0"
            max="12"
            value={normalized.conversionLagMonths}
            onChange={(e) =>
              update({
                conversionLagMonths: Math.min(
                  12,
                  Math.max(0, parseInt(e.target.value, 10) || 0)
                ),
              })
            }
          />
        </label>
        <label className="economics-field">
          <span>Base monthly signups</span>
          <input
            type="number"
            min="0"
            value={normalized.baseMonthlySignups}
            onChange={(e) =>
              update({ baseMonthlySignups: Math.max(0, parseFloat(e.target.value) || 0) })
            }
          />
          <span className="economics-muted">Used when Channels off; else Growth/Channels drive signups</span>
        </label>
        <label className="economics-field">
          <span>Signup growth % / mo</span>
          <input
            type="number"
            min="-50"
            max="100"
            step="0.5"
            value={normalized.signupGrowthPctMo}
            onChange={(e) =>
              update({
                signupGrowthPctMo: Math.min(
                  100,
                  Math.max(-50, parseFloat(e.target.value) || 0)
                ),
              })
            }
          />
          <span className="economics-muted">Legacy fallback when Growth tab is off</span>
        </label>
      </div>
    </section>
  );
}
